import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ISubscription } from '@rfm/shared-interfaces';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SubscriptionService } from '../../../../shared/services/products/subscription.service.mjs';

@Component({
  selector: 'app-subscription-view',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CardModule, ButtonModule, ProgressSpinnerModule],
  templateUrl: './subscription-view.component.html',
  styleUrls: ['./subscription-view.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class SubscriptionViewComponent implements OnInit {
  object: ISubscription | null = null; // Store the selected conduit details
  isLoading = false;

  constructor(private route: ActivatedRoute, private service: SubscriptionService) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.load(id);
    }
  }

  load(id: string): void {
    this.isLoading = true;
    this.service.get(id)
      .then((response) => {
        this.object = response?.data ?? null; // Handle null or undefined data
        this.isLoading = false;
      })
      .catch((error) => {
        console.error('Error fetching subscription details:', error);
        this.isLoading = false;
      });
  }
}
